import { Component, contentChild } from "@angular/core";
import { PageToolbarItemType } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";
import { TemplateDirective } from "src/app/modules/bootstrap/directives/common/template.directive";

@Component({
  selector: "snt-page-toolbar-custom",
  template: "",
  providers: [
    {
      provide: PageToolbarItemComponent,
      useExisting: PageToolbarCustomComponent
    }
  ],
  standalone: false
})
export class PageToolbarCustomComponent {
  type: PageToolbarItemType = "custom";

  template = contentChild<TemplateDirective | undefined>(TemplateDirective);
}
